var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(!_vm.loading && _vm.dish)?_c('v-card',{staticClass:"elevation-0 transparent"},[_c('dish-detail',{attrs:{"dish":_vm.dish}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }